export default __webpack_public_path__ + "static/media/photo--sm--47.c2cbba47.jpg";